export default function handleSubmit({ role, categories }, { props: { user, submit } }) {
  const request = {
    userId: user.id,
    roleId: role,
    categoryIds: categories,
  }

  return submit(request)
}
